import { ripsKeys, useTradingCardsClient } from '@/providers';
import { useQuery } from '@tanstack/react-query';

export type RipsCategory = {
    gameId: string;
    name: string;
    image: string;
    vendorId: string;
    packs: RipsPack[];
};

export enum RipsPackTier {
    Starter = 'starter',
    Premier = 'premier',
    Bronze = 'bronze',
    Silver = 'silver',
    Gold = 'gold',
    Sapphire = 'sapphire',
    Emerald = 'emerald',
    Ruby = 'ruby',
    Diamond = 'diamond',
}

export enum RipsPackStatus {
    Available = 'available',
    Restocking = 'restocking',
}

export type RipsPack = {
    vendorId: string;
    name: string;
    title: string;
    priceCents: number;
    minValue: number;
    maxValue: number;
    thumbnailUrl: string;
    /** Tier word, e.g. "Starter" or "Premier". Omitted when the pack has no tier. */
    badge?: RipsPackTier;
    status: RipsPackStatus;
};

type RipsGamesResponse = {
    categories: RipsCategory[];
};

/** Disabled, so it only fetches from the lobby's focus effect. */
export const useRipsGames = () => {
    const tradingCardsClient = useTradingCardsClient();

    return useQuery<RipsGamesResponse, Error, RipsCategory[]>({
        queryKey: ripsKeys.getGames(),
        queryFn: () => {
            return tradingCardsClient.fetch('/categories', {
                method: 'GET',
            });
        },
        select: response => response?.categories,
        staleTime: Infinity,
        enabled: false,
    });
};
